import * as React from 'react';

const ArrowIndigoRightAlt = () => (
  <svg
    width={14}
    height={12}
    viewBox="0 0 14 12"
    stroke="#283060"
    strokeWidth={2}
    fill="none"
    fillRule="evenodd"
    strokeLinecap="round"
    strokeLinejoin="round">
    <path d="M1,6 L13,6" />
    <polyline points="8 1 13 6 8 11" />
  </svg>
);

export default ArrowIndigoRightAlt;



// WEBPACK FOOTER //
// ./src/assets/images/icons/arrow-indigo-right-alt.js